<template>
  <div class="container">
    <div class="common-header-wrap">
      <mt-header title="عودة المبلغ" class="common-header">
        <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
      </mt-header>
    </div>
    <div class="menu">
      <div @click="$router.push({name:'MemberReturnList'})"><mt-cell class="menu-item" title="إدارة المرتجعات" is-link></mt-cell></div>
      <div @click="$router.push({name:'MemberRefundList'})"><mt-cell class="menu-item" title="إدارة الاسترداد" is-link></mt-cell></div>
      <div @click="$router.push({name:'MemberVrRefundList'})"><mt-cell class="menu-item" title="رد الظاهري" is-link></mt-cell></div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  components: {
  },
  data () {
    return {
    }
  },
  created () {

  },

  mounted () {

  },
  methods: {

  }
}
</script>
<style scoped lang="scss">

</style>
